import useCustomer from '@/hooks/user/useCustomer';
import { ESCRIPT_REFILL_ROUTE, PATIENT_REFILL_ROUTE } from '@/routes/route-paths';
import { Logger } from '@/utils/logger';
import { CircularProgressWrapper } from '@montugroup/circuit-shared/components/common/CircularProgressWrapper';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const logger = new Logger('home');

// This is to be hopefully expanded upon on Home page implementation
// At the moment it is a small component to assist in redirecting users
export function HomePage() {
  const { data: customer, isLoading: customerIsLoading } = useCustomer();

  const navigate = useNavigate();

  useEffect(() => {
    if (customerIsLoading || !customer) {
      return;
    }

    if (customer.isExternal) {
      logger.info('navigating to /escript/refill');
      navigate(ESCRIPT_REFILL_ROUTE, { replace: true });
      return;
    }
    logger.info('navigating to /patient/refill');

    navigate(PATIENT_REFILL_ROUTE, { replace: true });
  }, [navigate, customer, customerIsLoading]);

  return <CircularProgressWrapper />;
}

export default HomePage;
